import * as Schema from "effect/Schema";

import { FieldName } from "./form-field.js";

/** Glyphs an input may lead with (a subset of Duro's icon set). */
export const InputIcon = Schema.Literal("search", "mail", "lock", "key", "pin");

/**
 * InputWidget — one text field, backed by Duro `Input` (and `InputGroup` when
 * it has an icon). It owns its name, label and validation; what submitting
 * does belongs to the form (the section) it sits in — see FormConfig. Its
 * stable field id is the widget id, never `name`, so a later list binding
 * survives a rename.
 */
export const InputWidgetContent = Schema.Struct({
  contentType: Schema.Literal("input"),
  /** The submitted key (for a search box: `q`). */
  name: FieldName,
  /** Accessible name; required so the control is never unlabelled. */
  label: Schema.String.pipe(Schema.minLength(1)),
  placeholder: Schema.optional(Schema.String),
  type: Schema.optional(
    Schema.Literal("text", "search", "email", "url", "tel"),
  ),
  required: Schema.optional(Schema.Boolean),
  icon: Schema.optional(InputIcon),
});
export type InputWidgetContent = Schema.Schema.Type<typeof InputWidgetContent>;
